import "./ToggleIcon.scss";


import { ReactComponent as like } from "../../../../assets/icons/like.svg";
import { ReactComponent as save } from "../../../../assets/icons/save.svg";
import AcedTooltip from "../../tooltip/AcedTooltip";

const icons = {
  like,
  save,
};

export interface ToggleIconProps {
  onClick?: any;
  icon: "like" | "save";
  isToggled: any;
  fillColor?: string;
  tooltip?: string;
  size?: "s" | "m" | "l" | number;
}

const ToggleIcon: React.FC<ToggleIconProps> = ({
  onClick,
  icon,
  isToggled,
  fillColor,
  tooltip,
  size,
}) => {
  const Icon = icons[icon];

  if (!Icon) return null;

  const finalColor = fillColor ? fillColor : "white";

  const style = {
    "--t-icon-fill": finalColor,
  } as React.CSSProperties;

  const main = () => {
    return (
      <div
        style={style}
        onClick={onClick ? onClick : () => {}}
        className={`t-icon-button ${onClick && "t-icon-button-active"}`}
      >
        <Icon
          className={`t-icon-icon ${
            onClick ? "t-icon-active" : "t-icon-inactive"
          } ${isToggled && "t-icon-toggled"}`}
        />
      </div>
    );
  };
  return (
    <>
      {tooltip ? (
        <AcedTooltip text={tooltip}>{main()}</AcedTooltip>
      ) : (
        <>{main()}</>
      )}
    </>
  );
};

export default ToggleIcon;
